import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ProvinceActions from './province.actions';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ProvinceService } from 'src/app/api/services';

@Injectable()
export class ProvinceEffects {

  constructor(private actions$: Actions, private provinceService: ProvinceService) { }

  public loadAllProvinces$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProvinceActions.loadProvinces),
      switchMap(() =>
        this.provinceService.provinceGet().pipe(
          map((provinces) => ProvinceActions.loadProvincesSuccess({ data: provinces })),
          catchError((err) => of(ProvinceActions.loadProvincesFailure({ error: err })))
        )
      )
    );
  });
}
